package com.imobly.imobly.viewmodel

import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import androidx.navigation.NavHostController
import com.imobly.imobly.api.createHttpClient
import com.imobly.imobly.api.httpclient.GraphicHttpClient
import com.imobly.imobly.domain.graph.RentByMonth
import com.imobly.imobly.domain.graph.RentedProperties
import com.imobly.imobly.domain.graph.RentsPaidThisMonth
import kotlinx.coroutines.launch

class GraphicViewModel(private val navController: NavHostController) : ViewModel() {

    val inputErrors = mutableStateOf(emptyMap<String, String>())
    val messageError = mutableStateOf("")

    val showDialogState = mutableStateOf(false)

    val searchText: MutableState<String> = mutableStateOf("")

    val snackMessage: MutableState<SnackbarHostState> = mutableStateOf(SnackbarHostState())

    fun changeShowDialog() {
        showDialogState.value = !showDialogState.value
    }

    fun whenStartingThePage() {
        snackMessage.value = SnackbarHostState()
    }

    fun resetPage() {
        inputErrors.value = emptyMap()
        messageError.value = ""
    }

    fun changeSearchText(it: String) {
        searchText.value = it
    }

    fun goToHome() {
        navController.navigate("home")
    }

    var rentByMonth = mutableStateOf(RentByMonth())

    var rentedProperties = mutableStateOf(RentedProperties())

    var rentsPaidThisMonth = mutableStateOf(RentsPaidThisMonth())

    fun loadGraphics() {
        loadRentByMonth()
        loadRentedProperties()
        loadRentsPaidThisMonth()
    }

    fun loadRentByMonth() {
        viewModelScope.launch {
            val httpClient = GraphicHttpClient(createHttpClient())
            val list = httpClient.getChartRentByMonth()
            rentByMonth.value = list
        }
    }

    fun loadRentedProperties() {
        viewModelScope.launch {
            val httpClient = GraphicHttpClient(createHttpClient())
            val list = httpClient.getChartRentedProperties()
            rentedProperties.value = list
        }
    }

    fun loadRentsPaidThisMonth() {
        viewModelScope.launch {
            val httpClient = GraphicHttpClient(createHttpClient())
            val list = httpClient.getChartRentsPaidThisMonth()
            rentsPaidThisMonth.value = list
        }
    }
}
